import { render, staticRenderFns } from "./countryRiskDetail.vue?vue&type=template&id=d17209ba&scoped=true&"
import script from "./countryRiskDetail.vue?vue&type=script&lang=js&"
export * from "./countryRiskDetail.vue?vue&type=script&lang=js&"
import style0 from "./countryRiskDetail.vue?vue&type=style&index=0&id=d17209ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17209ba",
  null
  
)

export default component.exports